module.exports = __webpack_public_path__ + "img/avatar-3.41a180f3.jpg";